"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributeFilterTreeNodes = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const react_redux_1 = require("react-redux");
const client_constants_1 = require("../../../client/client.constants");
const product_tree_node_1 = require("../../../client/product-tree-node");
const product_tree_nodes_1 = require("../../../client/product-tree-nodes");
const hooks_1 = require("../../../hooks");
const attributes_filter_utils_1 = require("../../../preview-products-widget/strategy-attributes/attributes-filter/attributes-filter.utils");
const strategy_tree_utils_1 = require("../strategy-tree.utils");
const store_1 = require("../../../../store");
const useAttributeFilterTreeNodes = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const filterState = (0, store_1.useAttributesFilter)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const { showStrategyChanges } = (0, store_1.useProductTreeFilters)();
    const { checkIsNodeChanged } = (0, hooks_1.useStrategyNodeChanges)();
    const { selectedAttributes } = filterState;
    const shouldFilter = (0, strategy_tree_utils_1.shouldApplyAttributeFilter)(selectedAttributes);
    const filter = (0, react_1.useMemo)(() => {
        if (!shouldFilter || !(0, strategy_tree_utils_1.isSelectedAttributeList)(selectedAttributes))
            return undefined;
        const valuesByAttribute = (0, attributes_filter_utils_1.groupSelectedValuesByAttribute)(selectedAttributes, filterState.selectedValues);
        const excludedValuesByAttribute = (0, attributes_filter_utils_1.groupSelectedValuesByAttribute)(selectedAttributes, filterState.deselectedValues);
        return (0, product_tree_nodes_1.buildFilterToIncludeFilterItemsWithExcludedValues)(valuesByAttribute, excludedValuesByAttribute);
    }, [shouldFilter, selectedAttributes, filterState]);
    const queryVariables = {
        productTreeId,
        filter,
        sort: [{ distance: graphql_1.SortOrder.Asc }],
        first: client_constants_1.REQUEST_LIMIT_MEDIUM,
    };
    const { data } = (0, react_2.useQuery)(product_tree_nodes_1.GET_PRODUCT_TREE_NODE_PATHS, {
        skip: !filter || !productTreeId,
        variables: queryVariables,
        fetchPolicy: 'cache-and-network',
    });
    const nodePaths = (0, react_1.useMemo)(() => {
        const paths = (0, strategy_tree_utils_1.getPathsFromProductTreeNodes)(data);
        return (0, strategy_tree_utils_1.filterChangedNodePaths)(paths, showStrategyChanges, checkIsNodeChanged);
    }, [data, showStrategyChanges, checkIsNodeChanged]);
    // Extract L1 IDs from paths (second segment after root)
    const l1Ids = (0, react_1.useMemo)(() => {
        if (!nodePaths.length)
            return undefined;
        const ids = new Set();
        nodePaths.forEach((path) => {
            const segments = path.split(store_1.STRATEGY_NODE_PATH_SEPARATOR);
            if (segments.length > product_tree_node_1.L1_NODE_ANCESTOR_NUMBER)
                ids.add(segments[product_tree_node_1.L1_NODE_ANCESTOR_NUMBER]);
        });
        return [...ids];
    }, [nodePaths]);
    // Auto-expand matching paths when filter results change
    (0, react_1.useEffect)(() => {
        if (shouldFilter && nodePaths.length > 0) {
            dispatch((0, store_1.enrichAISetExpandedNodes)(nodePaths));
        }
    }, [shouldFilter, nodePaths, dispatch]);
    return {
        attributeFilterL1Ids: shouldFilter ? (l1Ids !== null && l1Ids !== void 0 ? l1Ids : []) : undefined,
        attributeFilterNodePaths: shouldFilter ? nodePaths : undefined,
        isAttributeFilterActive: shouldFilter,
    };
};
exports.useAttributeFilterTreeNodes = useAttributeFilterTreeNodes;
